(() => {
  const rootSelector = '[data-object-furniture-hub]';

  const initFurnitureHub = (root) => {
    if (!root || root.dataset.furnitureHubReady === 'true') return;
    root.dataset.furnitureHubReady = 'true';

    document.documentElement.classList.add('object-furniture-hub-active');

    const searchInput = root.querySelector('[data-furniture-search]');
    const searchJump = root.querySelector('[data-furniture-search-jump]');
    const categoryFilter = root.querySelector('[data-furniture-category-filter]');
    const sortSelect = root.querySelector('[data-furniture-sort]');
    const grid = root.querySelector('[data-furniture-product-grid]');
    const resultCount = root.querySelector('[data-furniture-result-count]');
    const emptyMessage = root.querySelector('[data-furniture-empty]');
    const loadMoreButton = root.querySelector('[data-furniture-load-more]');
    const initialPageSize = Math.max(1, Number(root.dataset.pageSize) || 12);

    if (searchJump && searchInput) {
      searchJump.addEventListener('click', () => {
        searchInput.scrollIntoView({ behavior: 'smooth', block: 'center' });
        window.setTimeout(() => searchInput.focus({ preventScroll: true }), 420);
      });
    }

    if (!grid) return;

    const cards = Array.from(grid.querySelectorAll('[data-furniture-card]'));
    let visibleLimit = initialPageSize;
    let inputTimer;

    const valueAsNumber = (card, name) => Number(card.dataset[name]) || 0;

    const sortCards = (items, sortValue) => {
      return items.sort((first, second) => {
        if (sortValue === 'price-asc') {
          return valueAsNumber(first, 'price') - valueAsNumber(second, 'price');
        }
        if (sortValue === 'price-desc') {
          return valueAsNumber(second, 'price') - valueAsNumber(first, 'price');
        }
        if (sortValue === 'newest') {
          return valueAsNumber(second, 'created') - valueAsNumber(first, 'created');
        }
        return valueAsNumber(first, 'position') - valueAsNumber(second, 'position');
      });
    };

    const applyFilters = () => {
      const query = (searchInput?.value || '').trim().toLocaleLowerCase('ja');
      const category = categoryFilter?.value || 'all';
      const sortValue = sortSelect?.value || 'manual';

      const matched = sortCards(
        cards.filter((card) => {
          const categoryMatch = category === 'all' || card.dataset.category === category;
          const searchMatch = query === '' || (card.dataset.search || '').includes(query);
          return categoryMatch && searchMatch;
        }),
        sortValue
      );

      const matchedSet = new Set(matched);
      const visibleCards = matched.slice(0, visibleLimit);
      const visibleSet = new Set(visibleCards);

      sortCards([...cards], sortValue).forEach((card) => grid.appendChild(card));
      cards.forEach((card) => {
        card.hidden = !matchedSet.has(card) || !visibleSet.has(card);
      });

      if (resultCount) {
        resultCount.textContent = `${matched.length} ITEM${matched.length === 1 ? '' : 'S'}`;
      }
      if (emptyMessage) emptyMessage.hidden = matched.length !== 0;
      if (loadMoreButton) loadMoreButton.hidden = matched.length <= visibleCards.length;
    };

    const resetAndApply = () => {
      visibleLimit = initialPageSize;
      applyFilters();
    };

    searchInput?.addEventListener('input', () => {
      window.clearTimeout(inputTimer);
      inputTimer = window.setTimeout(resetAndApply, 100);
    });
    categoryFilter?.addEventListener('change', resetAndApply);
    sortSelect?.addEventListener('change', resetAndApply);

    loadMoreButton?.addEventListener('click', () => {
      visibleLimit += initialPageSize;
      applyFilters();
    });

    root.querySelectorAll('[data-furniture-category-shortcut]').forEach((shortcut) => {
      shortcut.addEventListener('click', (event) => {
        if (!categoryFilter) return;
        event.preventDefault();
        categoryFilter.value = shortcut.dataset.furnitureCategoryShortcut || 'all';
        if (searchInput) searchInput.value = '';
        resetAndApply();
        root.querySelector('#explore')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });

    root.querySelector('[data-furniture-newest-jump]')?.addEventListener('click', () => {
      if (sortSelect) sortSelect.value = 'newest';
      if (categoryFilter) categoryFilter.value = 'all';
      if (searchInput) searchInput.value = '';
      resetAndApply();
      root.querySelector('#explore')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });

    applyFilters();
  };

  const initAll = (scope = document) => {
    scope.querySelectorAll(rootSelector).forEach(initFurnitureHub);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll());
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
  document.addEventListener('shopify:section:unload', () => {
    window.setTimeout(() => {
      if (!document.querySelector(rootSelector)) {
        document.documentElement.classList.remove('object-furniture-hub-active');
      }
    }, 0);
  });
})();
